import Logo from '../assets/images/logo.png'
import { useParams } from 'react-router-dom'
const Navbar = () => {

  let { mobileNum } = useParams()
  const a = mobileNum?.slice(0, 5)
  const b = mobileNum?.slice(7, 12)
  mobileNum = a + b || "+91 95001 39626"

  return (
    <div className="nav-container my-2">
      <nav class="navbar navbar-expand-lg bg-body-tertiary">
        <div class="container">
          <a class="navbar-brand" href="/" className="">
            <img src={Logo} alt="img" className="logo" />
          </a>
          <div className='d-md-block d-none'>
            <div className='d-flex contact-details'>
              <p className='contact mb-0'><i class="fa-solid fa-phone"></i></p>
              <p className='fw-bold mb-0 d-flex align-items-center'>{mobileNum}</p>
            </div>
            <div className='d-flex location-details'>
              <p className='location'><i class="fa-solid fa-location-dot"></i></p>
              <p className='fw-bold'>
                No 1055/3A,1B2,Periyar Colony,<br />
                Alamarathupatti Road,<br />
                Keela Thiruthangal,
                Sivakasi
              </p>
            </div>
          </div>
        </div>
      </nav >
    </div >
  )
}
export default Navbar